const ERROR_TOAST_EVENT = 'turn4:show-error-toast';

/**
 * Dispatch from anywhere (including module-scope code outside React)
 * to trigger an error toast. The ErrorToastListener component listens for this event.
 */
export function dispatchErrorToast(error: Error) {
  window.dispatchEvent(new CustomEvent(ERROR_TOAST_EVENT, { detail: error }));
}

export { ERROR_TOAST_EVENT };
